var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "031---University",
    fill: "current",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m59 53.278v-23.278c-.002755-.154684-.0421674-.3065077-.115-.443h.01l-2.448-4.895c-.5040262-1.0204856-1.5448336-1.6652197-2.683-1.662h-6.764v-1c-.0000566-.2651948-.1054506-.5195073-.293-.707l-5.414-5.414c-.3598517-.3561374-.805037-.6140213-1.293-.749v-6.745l2-.537v2.422.007c-.0011152 1.0268901.5120938 1.9861065 1.367 2.555.297245.1982824.6776931.2229246.9980331.0646441.3203401-.1582805.5319049-.4754371.555-.832s-.1457881-.6983617-.4430331-.8966441c-.2983566-.1982165-.4774779-.5328015-.477-.891v-.007-3.047c.6999806-.40430454 1.0877588-1.19022568.98273-1.9917267s-.6822116-1.46097353-1.46273-1.6712733l-13.006-3.492c-.3367586-.08998865-.6912414-.08998865-1.028 0l-13.006 3.492c-.8746544.23879072-1.4813577 1.03333504-1.4813577 1.94s.6067033 1.70120928 1.4813577 1.94l3.52.945v6.615h-.063c-.8890466.0004082-1.731866.3961668-2.3 1.08l-4.4 5.28c-.1516052.1789411-.2354937.4054754-.237.64v1h-6.764c-1.13726986-.0039706-2.17784711.6390696-2.683 1.658l-2.448 4.895h.01c-.07344731.137691-.11287866.2909589-.115.447v23.278c-.61675126.3544126-.997855 1.0106732-1 1.722v2c0 1.1045695.8954305 2 2 2h13.278c.3544126.6167513 1.0106732.997855 1.722 1h26c.7113268-.002145 1.3675874-.3832487 1.722-1h13.278c1.1045695 0 2-.8954305 2-2v-2c-.002145-.7113268-.3832487-1.3675874-1-1.722zm-15-.278h-1v-22h14v22zm-11 0h-6v-11h6zm1-13h-8c-.5522847 0-1 .4477153-1 1v12h-6v-22h22v22h-6v-12c0-.5522847-.4477153-1-1-1zm11-17v2h-30v-2zm-2 4v2h-26v-2zm10.764-2c.379067-.0012129.7258235.2132797.894.553l1.724 3.447h-11.382v-2c1.1045695 0 2-.8954305 2-2zm-23.764-23 13.014 3.5h-.013l-12.996 3.5-13.005-3.508zm-8 6.922 7.486 2.01c.3366717.0906485.6913283.0906485 1.028 0l7.486-2.01v6.078h-16zm-2.831 8.438c.1899089-.2280019.4712674-.3598887.768-.36h19.234c.2655413-.0002088.5202623.1052054.708.293l3.707 3.707h-27.451zm-13.827 8.193c.16817653-.3397203.51493301-.5542129.894-.553h6.764c0 1.1045695.8954305 2 2 2v2h-11.382zm-3.342 29.447h13v2h-13zm14-2h-13v-22h14v22zm1 5v-3h26v3zm41-1h-13v-2h13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27 33c-.5522847 0-1 .4477153-1 1v2c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-2c0-.5522847-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m13 34c-.5522847 0-1 .4477153-1 1v2c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-2c0-.5522847-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m7 34c-.55228475 0-1 .4477153-1 1v2c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-2c0-.5522847-.44771525-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m13 40c-.5522847 0-1 .4477153-1 1v2c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-2c0-.5522847-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m7 40c-.55228475 0-1 .4477153-1 1v2c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-2c0-.5522847-.44771525-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m13 46c-.5522847 0-1 .4477153-1 1v2c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-2c0-.5522847-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m7 46c-.55228475 0-1 .4477153-1 1v2c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-2c0-.5522847-.44771525-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m53 34c-.5522847 0-1 .4477153-1 1v2c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-2c0-.5522847-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m47 34c-.5522847 0-1 .4477153-1 1v2c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-2c0-.5522847-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m53 40c-.5522847 0-1 .4477153-1 1v2c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-2c0-.5522847-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m47 40c-.5522847 0-1 .4477153-1 1v2c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-2c0-.5522847-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m53 46c-.5522847 0-1 .4477153-1 1v2c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-2c0-.5522847-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m47 46c-.5522847 0-1 .4477153-1 1v2c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-2c0-.5522847-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m33 33c-.5522847 0-1 .4477153-1 1v2c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-2c0-.5522847-.4477153-1-1-1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhd);
export default __webpack_public_path__ + "static/media/phd.b7e9bbe9.svg";
export { ForwardRef as ReactComponent };